import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { DiffViewer } from '../DiffViewer/DiffViewer'
import { JsonEditor } from '../JsonEditor/JsonEditor'

import { Button, Flex, Grid } from '@percent/lemonade'
import styles from './StateMachineJsonVisualiser.module.scss'

interface StateMachineJsonVisualiserProps {
  originalJson: string
  editedJson: string
  onJsonChange: (value: string) => void
  onUpdate: () => void
  isUpdating: boolean
}

export function StateMachineJsonVisualiser({
  originalJson,
  editedJson,
  onJsonChange,
  onUpdate,
  isUpdating
}: Readonly<StateMachineJsonVisualiserProps>) {
  const { t } = useTranslation()
  const [isEditing, setIsEditing] = useState(false)

  return (
    <Flex direction="column" gap="xs">
      {isEditing ? (
        <Grid gutter="s" style={{ height: '500px' }}>
          <Grid.Col span={6} style={{ position: 'relative' }}>
            <JsonEditor
              editedJson={editedJson}
              onJsonChange={onJsonChange}
              onUpdate={onUpdate}
              isUpdating={isUpdating}
            />
          </Grid.Col>
          <Grid.Col span={6} style={{ position: 'relative' }}>
            <div className={styles.buttonContainer}>
              <Button size="small" variant="secondary" onClick={() => setIsEditing(false)}>
                {t('button.closeEditor')}
              </Button>
            </div>
            <DiffViewer originalJson={originalJson} editedJson={editedJson} />
          </Grid.Col>
        </Grid>
      ) : (
        <>
          <Flex justify="flex-end" style={{ marginBottom: 8 }}>
            <Button size="small" variant="secondary" onClick={() => setIsEditing(true)}>
              {t('button.editMode')}
            </Button>
          </Flex>
          <pre className={styles.codeBlock}>
            <code>{originalJson}</code>
          </pre>
        </>
      )}
    </Flex>
  )
}
